import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, homeFor } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RolePicker } from "@/components/RolePicker";
import { PageLoader } from "@/components/layout/RequireAuth";

export default function ChooseRole() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [role, setRole] = useState("pelanggan");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);

  if (user === null) return <PageLoader />;
  if (!user) return <Navigate to="/masuk" replace />;
  if (user.role) return <Navigate to={homeFor(user)} replace />;

  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/role", { role, phone });
      setUser(data);
      toast.success("Peran berhasil disimpan");
      navigate(role === "penyedia" ? "/dasbor/profil" : "/minta-penawaran", { replace: true });
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-page max-w-xl py-16 animate-fade-up" data-testid="choose-role-page">
      <p className="eyebrow">Satu langkah lagi</p>
      <h1 className="mt-3 text-3xl font-bold tracking-tight text-stone-900">Halo {user.name}, Anda ingin menggunakan Tuntas sebagai?</h1>
      <p className="mt-2 text-stone-500">Pilihan ini menentukan dasbor yang Anda lihat.</p>
      <div className="mt-8 space-y-6">
        <RolePicker value={role} onChange={setRole} />
        <div className="space-y-2">
          <Label htmlFor="phone">Nomor WhatsApp</Label>
          <Input id="phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="08xxxxxxxxxx"
            className="h-11 rounded-xl" data-testid="choose-role-phone-input" />
          <p className="text-xs text-stone-500">Dibagikan hanya setelah penawaran diterima.</p>
        </div>
        <Button onClick={submit} disabled={loading} data-testid="choose-role-submit-button" className="h-11 w-full rounded-xl bg-teal-700 font-semibold hover:bg-teal-800">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Lanjutkan
        </Button>
      </div>
    </div>
  );
}
